import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {actions, Form} from 'react-redux-form';
import {getUserAccessToken, updateUserAccessToken} from '../../../../../actions/app';
import BackLink from '../../../../common/back-link';
import PageTitle from '../../../../common/page-title';
import RequiredInput from '../../../../common/form/elements/required-input';
import Button from '../../../../common/button';
import RevokeCheckbox from './revoke-checkbox';
import {history} from '../../../../../store';

const PARENT_URL = '/admin/user-access-tokens';
const MODEL = 'deep.access_token_edit';

class UserAccessTokenEdit extends Component {
  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;
    const tokenId = this.props.match.params.token;

    dispatch(updateUserAccessToken(tokenId, payLoad)).then(() => {
      history.push(PARENT_URL);
    });
  };

  componentDidMount() {
    const {dispatch} = this.props;
    const tokenId = this.props.match.params.token;

    dispatch(getUserAccessToken(tokenId))
      .then(() => {
        dispatch(actions.load(MODEL, this.props.token)); // do not destruct token
      });
  }

  render() {
    const {loading, token} = this.props;

    if (loading || !token) {
      return <div>Loading...</div>;
    }

    const {name} = token;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <BackLink href={PARENT_URL}/>
            <PageTitle>Edit {name}'s auth token</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <Form model={MODEL} onSubmit={this.handleSubmit}>
              <RequiredInput model=".uid" paceholder="Authentication token" label="Authentication token"/>
              <RevokeCheckbox/>
              <Button submit>Save</Button>
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  token: state.accessTokens.userAccessToken,
  loading: !state.accessTokens.fetched && state.accessTokens.fetching
});

export default connect(mapStateToProps)(UserAccessTokenEdit);



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/edit/user-access-token-edit.jsx